module.exports = __webpack_public_path__ + "img/porsche-718-gts.b772f581.jpg";